'use client';

import { c as _c } from "react/compiler-runtime";
import * as qs from '@repo/sdk/qs';
import { Button, Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@repo/ui/components';
import { ChevronLeft } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib';
import { useSearchParams } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';
import { useWelcomeModalContext } from '@/app/_components/welcome-modal/context.tsx';
import { CallbackForm } from '@/app/_components/welcome-modal/forms/callback-form.tsx';
import { WelcomeModalFooter } from './_components/welcome-footer.tsx';
import { WelcomeModalHeader } from './_components/welcome-header.tsx';
import CheckEmailForm from './forms/check-email-form.tsx';
import LoginForm from './forms/login-form.tsx';
import NewUserForm from './forms/new-user-form.tsx';
import PhoneNumberForm from './forms/phone-number-form.tsx';
import { Success } from './forms/success.tsx';
export const WelcomeModal = () => {
  const $ = _c(52);
  const {
    header,
    isOpen,
    setIsOpen,
    setStep,
    step,
    subHeader
  } = useWelcomeModalContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["check-email"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [history, setHistory] = useState(t0);
  let t1;
  if ($[1] !== history || $[2] !== step) {
    t1 = () => {
      if (step !== history.at(-1)) {
        setHistory(prevHistory => [...prevHistory, step]);
      }
    };
    $[1] = history;
    $[2] = step;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== step) {
    t2 = [step];
    $[4] = step;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== history || $[7] !== setStep) {
    t3 = () => {
      history.pop();
      setStep(history.at(-1));
    };
    $[6] = history;
    $[7] = setStep;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const goBack = t3;
  let t4;
  bb0: switch (step) {
    case "callback":
      {
        let t5;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <CallbackForm />;
          $[9] = t5;
        } else {
          t5 = $[9];
        }
        t4 = t5;
        break bb0;
      }
    case "check-email":
      {
        let t5;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <CheckEmailForm />;
          $[10] = t5;
        } else {
          t5 = $[10];
        }
        t4 = t5;
        break bb0;
      }
    case "login":
      {
        let t5;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <LoginForm />;
          $[11] = t5;
        } else {
          t5 = $[11];
        }
        t4 = t5;
        break bb0;
      }
    case "new-user":
      {
        let t5;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <NewUserForm />;
          $[12] = t5;
        } else {
          t5 = $[12];
        }
        t4 = t5;
        break bb0;
      }
    case "phone-number":
      {
        let t5;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <PhoneNumberForm />;
          $[13] = t5;
        } else {
          t5 = $[13];
        }
        t4 = t5;
        break bb0;
      }
    case "success":
      {
        let t5;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <Success />;
          $[14] = t5;
        } else {
          t5 = $[14];
        }
        t4 = t5;
        break bb0;
      }
    default:
      {
        t4 = null;
      }
  }
  const form = t4;
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["callback", "success"];
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const isClosable = t5.includes(step);
  const t6 = useSearchParams();
  let t7;
  if ($[16] !== t6) {
    const searchParams = t6.toString();
    t7 = qs.parse(searchParams);
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const drops = t7;
  let t8;
  if ($[18] !== isClosable || $[19] !== setIsOpen) {
    t8 = () => isClosable && setIsOpen(false);
    $[18] = isClosable;
    $[19] = setIsOpen;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = step === "success" && "shadow-none focus-visible:outline-none";
  let t10;
  if ($[21] !== t9) {
    t10 = cn("top-[15%] translate-y-0 border-0 bg-transparent p-0", t9, "transform transition-all duration-200", "overflow-auto max-sm:top-0 max-sm:h-svh max-sm:max-w-full");
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== drops || $[24] !== goBack || $[25] !== step) {
    t11 = drops.origin && drops.destination && <WelcomeModalHeader closeable={["callback", "success"].includes(step)} drops={!["callback", "success"].includes(step) ? drops : undefined} goBack={!["callback", "check-email", "phone-number", "success"].includes(step) ? goBack : undefined} />;
    $[23] = drops;
    $[24] = goBack;
    $[25] = step;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== goBack || $[28] !== header || $[29] !== step || $[30] !== subHeader) {
    t12 = step !== "success" && <DialogHeader><div className="relative">{!["callback", "check-email", "phone-number", "success"].includes(step) && <Button className={cn("absolute -top-1 -left-2 aspect-square translate-y-[1px]")} onClick={goBack} size="icon" variant="ghost"><ChevronLeft className="stroke-brand !size-6" /></Button>}<DialogTitle className="mb-4 text-center text-[32px] leading-9 font-semibold text-balance text-gray-700 dark:text-gray-300">{header}</DialogTitle></div>{subHeader && step !== "phone-number" && <DialogDescription className="mb-2 text-center text-gray-700 dark:text-gray-300">{subHeader}</DialogDescription>}</DialogHeader>;
    $[27] = goBack;
    $[28] = header;
    $[29] = step;
    $[30] = subHeader;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== form) {
    t13 = <div className="flex flex-col gap-4 [&_button.rounded-md]:!rounded-xl [&_input]:!rounded-xl">{form}</div>;
    $[32] = form;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== step || $[35] !== subHeader) {
    t14 = subHeader && step === "phone-number" && <DialogDescription className="mt-3 text-center text-sm text-gray-700 dark:text-gray-300">*{subHeader}</DialogDescription>;
    $[34] = step;
    $[35] = subHeader;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t12 || $[38] !== t13 || $[39] !== t14) {
    t15 = <div className="overflow-y flex min-h-0 flex-grow flex-col p-8 max-sm:p-4">{t12}{t13}{t14}</div>;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="p-8 max-sm:p-4 sm:hidden"><WelcomeModalFooter /></div>;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t11 || $[43] !== t15) {
    t17 = <div className="bg-background relative flex h-full flex-col rounded-lg max-sm:rounded-none sm:shadow-lg">{t11}{t15}{t16}</div>;
    $[42] = t11;
    $[43] = t15;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t10 || $[46] !== t17) {
    t18 = <DialogContent className={t10}>{t17}</DialogContent>;
    $[45] = t10;
    $[46] = t17;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== isOpen || $[49] !== t18 || $[50] !== t8) {
    t19 = <Dialog onOpenChange={t8} open={isOpen}>{t18}</Dialog>;
    $[48] = isOpen;
    $[49] = t18;
    $[50] = t8;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  return t19;
};